import React from 'react';
import MetabaseAnalytics from '../../components/MetabaseAnalytics';

const CustomAnalytics = () => {
    return (
        <>
            <header className="top-header">
                <div className="breadcrumb">
                    <span>Analytics</span>
                    <span className="breadcrumb-separator">/</span>
                    <span className="breadcrumb-current">Custom Analytics</span>
                </div>
            </header>
            <div className="custom-analytics-page">
                <MetabaseAnalytics />
            </div>
        </>
    );
};

export default CustomAnalytics;
